import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBeatMarkerCloseIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	role: "img",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 14L14 4M14 14L4 4",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBeatMarkerCloseIcon;
